<!--
  lovi
  修改登录密码 2020-1-14
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('securitySet.modifyLoginPsd')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper logReg-field">
      <h3></h3>
      <ul>
        <li>
          <van-cell-group>
            <van-field
              clearable
              left-icon="icon-lock"
              :right-icon="eye ? 'eye-o' : 'closed-eye'"
              @click-right-icon="eye = !eye"
              :type="eye ? 'text' : 'password'"
              v-model="oldPsd"
              :error="error.oldPsd ? true : false"
              @input="verifyOldPsd"
              :placeholder="$t('securitySet.oldPsd')"
            />
          </van-cell-group>
        </li>
        <li>
          <van-cell-group>
            <van-field
              clearable
              left-icon="icon-lock"
              :type="eye ? 'text' : 'password'"
              v-model="newPsd"
              :error="error.newPsd ? true : false"
              @input="verifyNewPsd"
              :placeholder="$t('securitySet.newPsd')"
            />
          </van-cell-group>
        </li>
        <li>
          <van-button
            round
            type="primary"
            block
            :loading="btnLoading"
            @click="submit"
          >
            {{ $t("common.confirm") }}
          </van-button>
        </li>
        <li class="text-list">
          <span class="text-orange" @click="forgetPsd">
            {{ $t("common.forgetPassword") }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
export default {
  name: "modifyPsd",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      btnLoading: false, //按钮load
      eye: false,

      newPsd: "",
      oldPsd: "",
      error: {
        newPsd: false,
        oldPsd: false
      }
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    forgetPsd() {
      // 忘记密码
      this.$router.push({
        path: "/mobile",
        name: "mobile",
        query: { flag: "forgetPsd" }
      });
    },
    verifyOldPsd() {
      // 验证旧密码
      this.error.oldPsd = validate.validatePsd(this.oldPsd);
    },
    verifyNewPsd() {
      // 验证新密码
      this.error.newPsd = validate.validatePsd(this.newPsd);
    },
    submit() {
      let vm = this;
      vm.verifyOldPsd();
      vm.verifyNewPsd();
      for (let key in vm.error) {
        if (vm.error[key]) {
          vm.$toast(vm.error[key]);
          return false;
        }
      }
      let params = {};
      params.original_password = vm.oldPsd;
      params.password = vm.newPsd;
      vm.btnLoading = true;
      vm.$post("/app/user/userPassword", params, { alert: true }).then(res => {
        console.log("userPassword", res);
        vm.btnLoading = false;
        vm.$toast(res.msg);
        if (res.code == 0) {
          localStorage.setItem("token", "");
          vm.$store.dispatch("SET_TOKEN", "");
          vm.$store.dispatch("GET_USER_INFO", { obj: "delete" });
          this.$router.push({
            path: "/logReg"
          });
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.text-list {
  text-align: right;
}
</style>
